import { Component, inject, OnInit } from '@angular/core';
import { AppAuthService, LowScoreFallbackRequiredError } from './app-auth.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { NotificationService } from '../service/notification.service';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '..';
import { RecaptchaV2FallbackComponent } from './recaptcha-v2-fallback.component';

function isAccountDisabledError(err: unknown): boolean {
  const e = err as { status?: number; error?: { error_type?: string } };
  return e?.status === 403 && e?.error?.error_type === 'account_disabled';
}

@Component({
  selector: 'app-register',
  templateUrl: 'register-confirm.component.html',
  styleUrls: ['login-reset-register.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    RouterModule,
    TranslateModule,
    RecaptchaV2FallbackComponent,
  ],
})
export class RegisterConfirmComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(AppAuthService);
  private readonly route = inject(ActivatedRoute);
  private readonly toastr = inject(NotificationService);
  private readonly translate = inject(TranslationService);
  showV2Fallback = false;
  private confirmToken!: string;

  async ngOnInit() {
    this.confirmToken = this.route.snapshot.params['token'];
    try {
      const user = await this.authService.registerConfirm(this.confirmToken);
      if (user) {
        this.toastr.success('your_account_is_successfully_activated_tr');
        await this.router.navigate(['/']);
      }
    } catch (err) {
      if (err instanceof LowScoreFallbackRequiredError) {
        this.showV2Fallback = true;
        return;
      }
      if (isAccountDisabledError(err)) {
        await this.router.navigate(['/waiting']);
        return;
      }
      throw err;
    }
  }

  async onV2Solved(token: string) {
    try {
      const user = await this.authService.registerConfirm(this.confirmToken, token);
      this.showV2Fallback = false;
      if (user) {
        this.toastr.success('your_account_is_successfully_activated_tr');
        await this.router.navigate(['/']);
      }
    } catch (err) {
      if (err instanceof LowScoreFallbackRequiredError) {
        // server rejected v2 token too — leave widget visible so user can retry
        return;
      }
      this.showV2Fallback = false;
      if (isAccountDisabledError(err)) {
        await this.router.navigate(['/waiting']);
        return;
      }
      throw err;
    }
  }
}
